import React from "react";
import {
  HeroContentPostBase,
  Wrapper,
  ImageWrapper,
  Text,
  Title,
  Subtitle,
  MetaText,
  AuthorText,
  ReadTime,
} from "./hero-content-post.styled";
import {
  HeroContentPostFragment,
  AuthorContentPostFragment,
} from "../../types/graphql";
import { GatsbyImage } from "gatsby-plugin-image";
import Breadcrumbs, { BreadCrumbProps } from "../breadcrumbs/breadcrumbs";
import * as FA from "../../styles/fontawesome";
import HeroContentPostAuthor from "./hero-content-post-author";

interface IHeroContentPostProps {
  heroContentPost: HeroContentPostFragment;
  author: AuthorContentPostFragment | undefined | null;
  editor: AuthorContentPostFragment | undefined | null;
  breadcrumbs: BreadCrumbProps[];
  readTime?: string | null;
  publicationDate?: string | null;
  editedDate?: string | null;
}

const HeroContentPost = (props: IHeroContentPostProps) => {
  const {
    heroContentPost: { data: hero },
    author,
    editor,
    breadcrumbs,
    publicationDate,
    editedDate,
  } = props;

  return (
    (hero && (
      <>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <HeroContentPostBase>
          <Wrapper>
            <Text>
              {hero.title && <Title>{hero.title}</Title>}
              <MetaText>
                {author && (
                  <HeroContentPostAuthor author={author} type="author" />
                )}
                {editor && (
                  <HeroContentPostAuthor author={editor} type="editor" />
                )}
                {props.readTime && hero.content_type == "Article" && (
                  <ReadTime>
                    <i css={FA.ClockSolid} />
                    &nbsp;{props.readTime}
                    {publicationDate && (
                      <AuthorText>Published {publicationDate}</AuthorText>
                    )}
                    {publicationDate != editedDate && editor && (
                      <AuthorText>Updated {editedDate}</AuthorText>
                    )}
                  </ReadTime>
                )}
              </MetaText>
              {hero.subtitle && <Subtitle>{hero.subtitle}</Subtitle>}
            </Text>
            {hero.image?.gatsbyImageData && (
              <ImageWrapper>
                <GatsbyImage
                  image={hero.image.gatsbyImageData}
                  alt={hero.image.alt || "Xometry Image"}
                />
              </ImageWrapper>
            )}
          </Wrapper>
        </HeroContentPostBase>
      </>
    )) || <></>
  );
};

export default HeroContentPost;
